
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as cartCJaaBcqbjwkqG_45OpNeWdWtb1NMP8QvcPRgSs2jJVfrMMeta } from "D:/dev_web/pages/cart.vue?macro=true";
import { default as indexVSlRMYkdAfycFzqOGOdAgWr_45WO6QvSzmt4yCofhx8S0Meta } from "D:/dev_web/pages/index.vue?macro=true";
import { default as logindFLvc7GwtDC8UyiqkhU0MoInXH_457yqA0D7tJ_4e6O0gMeta } from "D:/dev_web/pages/login.vue?macro=true";
import { default as ordersO1DNJQp6keX4RprGZyDSnTemygrtomY5Q4s5uhDfmDUMeta } from "D:/dev_web/pages/orders.vue?macro=true";
import { default as accounttYwPw_45rF_45lH1dtjCPCHybOZYR1aAHt2HwEi9K91YxdcMeta } from "D:/dev_web/pages/account.vue?macro=true";
import { default as checkoutxC0YwYt_mGqzPl74fLKXGaS3Bc_vT1cId8h3QbcbmQAMeta } from "D:/dev_web/pages/checkout.vue?macro=true";
import { default as rechargeeFtsVEfRkNl6LuY9K6_454cysvbgITUI3ZGDksvClhxHsMeta } from "D:/dev_web/pages/recharge.vue?macro=true";
import { default as register_45HARWC7TPnRRmwlgndAI8KkI5BAPoWsLNbQCgTUysM0Meta } from "D:/dev_web/pages/register.vue?macro=true";
import { default as transferiWQa59cOzyjlB3pIYcRGIPjiJkB8weqroe_45k0SISX50Meta } from "D:/dev_web/pages/transfer.vue?macro=true";
import { default as _91_46_46_46slug_93bnXTOC58QBsbMQIXWdaC0peYXs6ecAOpPNvhaOwvSEsMeta } from "D:/dev_web/pages/[...slug].vue?macro=true";
import { default as bus_45ticketldnI3XNDcj4oskKUhGkNA_BM2pB_6JY7R2nP8jyyEgkMeta } from "D:/dev_web/pages/bus-ticket.vue?macro=true";
import { default as _91id_93Y9ZvcaW0j8SuBZgvSTv7vZJiIqI9pbRbxnnS7eYui_sMeta } from "D:/dev_web/pages/order/[id].vue?macro=true";
import { default as book_45ticketUyPv7OB1Oe4YwfzzE0FCpxocGzyXhSyuG6NWt_458Cyl8Meta } from "D:/dev_web/pages/book-ticket.vue?macro=true";
import { default as investmentsl0PjMYZF6SB_45xLDy3gwmmPuuCGCbpoCTSkk6Yx4LdWEMeta } from "D:/dev_web/pages/investments.vue?macro=true";
import { default as account_45editYCiTAZeFE_8ODzepXs6BmkBv1qbbPoxQoHgE4aBrMSEMeta } from "D:/dev_web/pages/account-edit.vue?macro=true";
import { default as login_45qrcodeYBsX2u5TB5_zC0Gqf7Ci4U2w4mTGamA1x_450w2rVlSUsMeta } from "D:/dev_web/pages/login-qrcode.vue?macro=true";
import { default as order_45result_45lzoBWYFP_0wTyU6tGHoUnIFgNrLzIPK86t7w5D6McEMeta } from "D:/dev_web/pages/order-result.vue?macro=true";
import { default as recharge_45logamm70Srqa4B6hv0F_45Vkba_85h3XOcMshJowVDkvRCTIMeta } from "D:/dev_web/pages/recharge-log.vue?macro=true";
import { default as transfer_45logNsNKVj5Yu28dxNlTI0a9_45dl6XihsEU_45t_45NDODhxGRAsMeta } from "D:/dev_web/pages/transfer-log.vue?macro=true";
import { default as order_45checkout5S51eKSC_jjyMU2tcQd8hNweJ9pNO4VwMuDoDq3i0hwMeta } from "D:/dev_web/pages/order-checkout.vue?macro=true";
import { default as reset_45password6LKeNpPJyH8XCJ6969NtNmvwNPr_454t8_45KYEP_JMTx0YMeta } from "D:/dev_web/pages/reset-password.vue?macro=true";
import { default as _91_46_46_46slug_93oKIuSffTVO_45ftBU9xPgKmAl25gBVH_oCJFMPItd91QgMeta } from "D:/dev_web/pages/shop/[...slug].vue?macro=true";
import { default as change_45passwordBXBwxR2orpLIkK7BtWkY2qdND4bbM_451yMeX_451Uv8CCkMeta } from "D:/dev_web/pages/change-password.vue?macro=true";
import { default as checkout_45paypalCdfGrQD529a7Gek6gusZsaGRzMtzyRpog63ModoLOJkMeta } from "D:/dev_web/pages/checkout-paypal.vue?macro=true";
import { default as forgot_45passwordFRB76gsXqGS_452ijKfAri4cBi1pvK9Whh9VZxDma1hJoMeta } from "D:/dev_web/pages/forgot-password.vue?macro=true";
import { default as checkout_45balancesCjFrytgd_45TES8jvv4oQ3glNi8grAplHDM8Q_45lwSFFgMeta } from "D:/dev_web/pages/checkout-balance.vue?macro=true";
import { default as checkout_45successykrUJfWzhHTMizBtlTaYBXmgurT8__VvQnevrG1a5TQMeta } from "D:/dev_web/pages/checkout-success.vue?macro=true";
import { default as _91id_93P7Lr1Mw2Rhs3hADyWOFGtUH0Z6kBgwGU0rVVeJA0Wu0Meta } from "D:/dev_web/pages/order-qrcode/[id].vue?macro=true";
import { default as checkout_45paypal_45successCKEVeQKCr_45jMHGoGHnntiYTDHBnzDWGlRuh2eTsKOAgMeta } from "D:/dev_web/pages/checkout-paypal-success.vue?macro=true";
export default [
  {
    name: "cart___en___default",
    path: "/cart",
    meta: cartCJaaBcqbjwkqG_45OpNeWdWtb1NMP8QvcPRgSs2jJVfrMMeta || {},
    component: () => import("D:/dev_web/pages/cart.vue")
  },
  {
    name: "cart___en",
    path: "/en/cart",
    meta: cartCJaaBcqbjwkqG_45OpNeWdWtb1NMP8QvcPRgSs2jJVfrMMeta || {},
    component: () => import("D:/dev_web/pages/cart.vue")
  },
  {
    name: "cart___vi",
    path: "/vi/cart",
    meta: cartCJaaBcqbjwkqG_45OpNeWdWtb1NMP8QvcPRgSs2jJVfrMMeta || {},
    component: () => import("D:/dev_web/pages/cart.vue")
  },
  {
    name: "cart___cn",
    path: "/cn/cart",
    meta: cartCJaaBcqbjwkqG_45OpNeWdWtb1NMP8QvcPRgSs2jJVfrMMeta || {},
    component: () => import("D:/dev_web/pages/cart.vue")
  },
  {
    name: "index___en___default",
    path: "/",
    meta: indexVSlRMYkdAfycFzqOGOdAgWr_45WO6QvSzmt4yCofhx8S0Meta || {},
    component: () => import("D:/dev_web/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexVSlRMYkdAfycFzqOGOdAgWr_45WO6QvSzmt4yCofhx8S0Meta || {},
    component: () => import("D:/dev_web/pages/index.vue")
  },
  {
    name: "index___vi",
    path: "/vi",
    meta: indexVSlRMYkdAfycFzqOGOdAgWr_45WO6QvSzmt4yCofhx8S0Meta || {},
    component: () => import("D:/dev_web/pages/index.vue")
  },
  {
    name: "index___cn",
    path: "/cn",
    meta: indexVSlRMYkdAfycFzqOGOdAgWr_45WO6QvSzmt4yCofhx8S0Meta || {},
    component: () => import("D:/dev_web/pages/index.vue")
  },
  {
    name: "login___en___default",
    path: "/login",
    meta: { ...(logindFLvc7GwtDC8UyiqkhU0MoInXH_457yqA0D7tJ_4e6O0gMeta || {}), ...{"middleware":["hidewhenauth"]} },
    component: () => import("D:/dev_web/pages/login.vue")
  },
  {
    name: "login___en",
    path: "/en/login",
    meta: { ...(logindFLvc7GwtDC8UyiqkhU0MoInXH_457yqA0D7tJ_4e6O0gMeta || {}), ...{"middleware":["hidewhenauth"]} },
    component: () => import("D:/dev_web/pages/login.vue")
  },
  {
    name: "login___vi",
    path: "/vi/login",
    meta: { ...(logindFLvc7GwtDC8UyiqkhU0MoInXH_457yqA0D7tJ_4e6O0gMeta || {}), ...{"middleware":["hidewhenauth"]} },
    component: () => import("D:/dev_web/pages/login.vue")
  },
  {
    name: "login___cn",
    path: "/cn/login",
    meta: { ...(logindFLvc7GwtDC8UyiqkhU0MoInXH_457yqA0D7tJ_4e6O0gMeta || {}), ...{"middleware":["hidewhenauth"]} },
    component: () => import("D:/dev_web/pages/login.vue")
  },
  {
    name: "orders___en___default",
    path: "/orders",
    meta: { ...(ordersO1DNJQp6keX4RprGZyDSnTemygrtomY5Q4s5uhDfmDUMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/dev_web/pages/orders.vue")
  },
  {
    name: "orders___en",
    path: "/en/orders",
    meta: { ...(ordersO1DNJQp6keX4RprGZyDSnTemygrtomY5Q4s5uhDfmDUMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/dev_web/pages/orders.vue")
  },
  {
    name: "orders___vi",
    path: "/vi/orders",
    meta: { ...(ordersO1DNJQp6keX4RprGZyDSnTemygrtomY5Q4s5uhDfmDUMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/dev_web/pages/orders.vue")
  },
  {
    name: "orders___cn",
    path: "/cn/orders",
    meta: { ...(ordersO1DNJQp6keX4RprGZyDSnTemygrtomY5Q4s5uhDfmDUMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/dev_web/pages/orders.vue")
  },
  {
    name: "account___en___default",
    path: "/account",
    meta: { ...(accounttYwPw_45rF_45lH1dtjCPCHybOZYR1aAHt2HwEi9K91YxdcMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/dev_web/pages/account.vue")
  },
  {
    name: "account___en",
    path: "/en/account",
    meta: { ...(accounttYwPw_45rF_45lH1dtjCPCHybOZYR1aAHt2HwEi9K91YxdcMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/dev_web/pages/account.vue")
  },
  {
    name: "account___vi",
    path: "/vi/account",
    meta: { ...(accounttYwPw_45rF_45lH1dtjCPCHybOZYR1aAHt2HwEi9K91YxdcMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/dev_web/pages/account.vue")
  },
  {
    name: "account___cn",
    path: "/cn/account",
    meta: { ...(accounttYwPw_45rF_45lH1dtjCPCHybOZYR1aAHt2HwEi9K91YxdcMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/dev_web/pages/account.vue")
  },
  {
    name: "checkout___en___default",
    path: "/checkout",
    meta: checkoutxC0YwYt_mGqzPl74fLKXGaS3Bc_vT1cId8h3QbcbmQAMeta || {},
    component: () => import("D:/dev_web/pages/checkout.vue")
  },
  {
    name: "checkout___en",
    path: "/en/checkout",
    meta: checkoutxC0YwYt_mGqzPl74fLKXGaS3Bc_vT1cId8h3QbcbmQAMeta || {},
    component: () => import("D:/dev_web/pages/checkout.vue")
  },
  {
    name: "checkout___vi",
    path: "/vi/checkout",
    meta: checkoutxC0YwYt_mGqzPl74fLKXGaS3Bc_vT1cId8h3QbcbmQAMeta || {},
    component: () => import("D:/dev_web/pages/checkout.vue")
  },
  {
    name: "checkout___cn",
    path: "/cn/checkout",
    meta: checkoutxC0YwYt_mGqzPl74fLKXGaS3Bc_vT1cId8h3QbcbmQAMeta || {},
    component: () => import("D:/dev_web/pages/checkout.vue")
  },
  {
    name: "recharge___en___default",
    path: "/recharge",
    meta: { ...(rechargeeFtsVEfRkNl6LuY9K6_454cysvbgITUI3ZGDksvClhxHsMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/dev_web/pages/recharge.vue")
  },
  {
    name: "recharge___en",
    path: "/en/recharge",
    meta: { ...(rechargeeFtsVEfRkNl6LuY9K6_454cysvbgITUI3ZGDksvClhxHsMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/dev_web/pages/recharge.vue")
  },
  {
    name: "recharge___vi",
    path: "/vi/recharge",
    meta: { ...(rechargeeFtsVEfRkNl6LuY9K6_454cysvbgITUI3ZGDksvClhxHsMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/dev_web/pages/recharge.vue")
  },
  {
    name: "recharge___cn",
    path: "/cn/recharge",
    meta: { ...(rechargeeFtsVEfRkNl6LuY9K6_454cysvbgITUI3ZGDksvClhxHsMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/dev_web/pages/recharge.vue")
  },
  {
    name: "register___en___default",
    path: "/register",
    meta: { ...(register_45HARWC7TPnRRmwlgndAI8KkI5BAPoWsLNbQCgTUysM0Meta || {}), ...{"middleware":["hidewhenauth"]} },
    component: () => import("D:/dev_web/pages/register.vue")
  },
  {
    name: "register___en",
    path: "/en/register",
    meta: { ...(register_45HARWC7TPnRRmwlgndAI8KkI5BAPoWsLNbQCgTUysM0Meta || {}), ...{"middleware":["hidewhenauth"]} },
    component: () => import("D:/dev_web/pages/register.vue")
  },
  {
    name: "register___vi",
    path: "/vi/register",
    meta: { ...(register_45HARWC7TPnRRmwlgndAI8KkI5BAPoWsLNbQCgTUysM0Meta || {}), ...{"middleware":["hidewhenauth"]} },
    component: () => import("D:/dev_web/pages/register.vue")
  },
  {
    name: "register___cn",
    path: "/cn/register",
    meta: { ...(register_45HARWC7TPnRRmwlgndAI8KkI5BAPoWsLNbQCgTUysM0Meta || {}), ...{"middleware":["hidewhenauth"]} },
    component: () => import("D:/dev_web/pages/register.vue")
  },
  {
    name: "transfer___en___default",
    path: "/transfer",
    meta: { ...(transferiWQa59cOzyjlB3pIYcRGIPjiJkB8weqroe_45k0SISX50Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/dev_web/pages/transfer.vue")
  },
  {
    name: "transfer___en",
    path: "/en/transfer",
    meta: { ...(transferiWQa59cOzyjlB3pIYcRGIPjiJkB8weqroe_45k0SISX50Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/dev_web/pages/transfer.vue")
  },
  {
    name: "transfer___vi",
    path: "/vi/transfer",
    meta: { ...(transferiWQa59cOzyjlB3pIYcRGIPjiJkB8weqroe_45k0SISX50Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/dev_web/pages/transfer.vue")
  },
  {
    name: "transfer___cn",
    path: "/cn/transfer",
    meta: { ...(transferiWQa59cOzyjlB3pIYcRGIPjiJkB8weqroe_45k0SISX50Meta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/dev_web/pages/transfer.vue")
  },
  {
    name: "slug___en___default",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93bnXTOC58QBsbMQIXWdaC0peYXs6ecAOpPNvhaOwvSEsMeta || {},
    component: () => import("D:/dev_web/pages/[...slug].vue")
  },
  {
    name: "slug___en",
    path: "/en/:slug(.*)*",
    meta: _91_46_46_46slug_93bnXTOC58QBsbMQIXWdaC0peYXs6ecAOpPNvhaOwvSEsMeta || {},
    component: () => import("D:/dev_web/pages/[...slug].vue")
  },
  {
    name: "slug___vi",
    path: "/vi/:slug(.*)*",
    meta: _91_46_46_46slug_93bnXTOC58QBsbMQIXWdaC0peYXs6ecAOpPNvhaOwvSEsMeta || {},
    component: () => import("D:/dev_web/pages/[...slug].vue")
  },
  {
    name: "slug___cn",
    path: "/cn/:slug(.*)*",
    meta: _91_46_46_46slug_93bnXTOC58QBsbMQIXWdaC0peYXs6ecAOpPNvhaOwvSEsMeta || {},
    component: () => import("D:/dev_web/pages/[...slug].vue")
  },
  {
    name: "bus-ticket___en___default",
    path: "/bus-ticket",
    meta: bus_45ticketldnI3XNDcj4oskKUhGkNA_BM2pB_6JY7R2nP8jyyEgkMeta || {},
    component: () => import("D:/dev_web/pages/bus-ticket.vue")
  },
  {
    name: "bus-ticket___en",
    path: "/en/bus-ticket",
    meta: bus_45ticketldnI3XNDcj4oskKUhGkNA_BM2pB_6JY7R2nP8jyyEgkMeta || {},
    component: () => import("D:/dev_web/pages/bus-ticket.vue")
  },
  {
    name: "bus-ticket___vi",
    path: "/vi/bus-ticket",
    meta: bus_45ticketldnI3XNDcj4oskKUhGkNA_BM2pB_6JY7R2nP8jyyEgkMeta || {},
    component: () => import("D:/dev_web/pages/bus-ticket.vue")
  },
  {
    name: "bus-ticket___cn",
    path: "/cn/bus-ticket",
    meta: bus_45ticketldnI3XNDcj4oskKUhGkNA_BM2pB_6JY7R2nP8jyyEgkMeta || {},
    component: () => import("D:/dev_web/pages/bus-ticket.vue")
  },
  {
    name: "order-id___en___default",
    path: "/order/:id()",
    meta: _91id_93Y9ZvcaW0j8SuBZgvSTv7vZJiIqI9pbRbxnnS7eYui_sMeta || {},
    component: () => import("D:/dev_web/pages/order/[id].vue")
  },
  {
    name: "order-id___en",
    path: "/en/order/:id()",
    meta: _91id_93Y9ZvcaW0j8SuBZgvSTv7vZJiIqI9pbRbxnnS7eYui_sMeta || {},
    component: () => import("D:/dev_web/pages/order/[id].vue")
  },
  {
    name: "order-id___vi",
    path: "/vi/order/:id()",
    meta: _91id_93Y9ZvcaW0j8SuBZgvSTv7vZJiIqI9pbRbxnnS7eYui_sMeta || {},
    component: () => import("D:/dev_web/pages/order/[id].vue")
  },
  {
    name: "order-id___cn",
    path: "/cn/order/:id()",
    meta: _91id_93Y9ZvcaW0j8SuBZgvSTv7vZJiIqI9pbRbxnnS7eYui_sMeta || {},
    component: () => import("D:/dev_web/pages/order/[id].vue")
  },
  {
    name: "book-ticket___en___default",
    path: "/book-ticket",
    meta: book_45ticketUyPv7OB1Oe4YwfzzE0FCpxocGzyXhSyuG6NWt_458Cyl8Meta || {},
    component: () => import("D:/dev_web/pages/book-ticket.vue")
  },
  {
    name: "book-ticket___en",
    path: "/en/book-ticket",
    meta: book_45ticketUyPv7OB1Oe4YwfzzE0FCpxocGzyXhSyuG6NWt_458Cyl8Meta || {},
    component: () => import("D:/dev_web/pages/book-ticket.vue")
  },
  {
    name: "book-ticket___vi",
    path: "/vi/book-ticket",
    meta: book_45ticketUyPv7OB1Oe4YwfzzE0FCpxocGzyXhSyuG6NWt_458Cyl8Meta || {},
    component: () => import("D:/dev_web/pages/book-ticket.vue")
  },
  {
    name: "book-ticket___cn",
    path: "/cn/book-ticket",
    meta: book_45ticketUyPv7OB1Oe4YwfzzE0FCpxocGzyXhSyuG6NWt_458Cyl8Meta || {},
    component: () => import("D:/dev_web/pages/book-ticket.vue")
  },
  {
    name: "investments___en___default",
    path: "/investments",
    meta: { ...(investmentsl0PjMYZF6SB_45xLDy3gwmmPuuCGCbpoCTSkk6Yx4LdWEMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/dev_web/pages/investments.vue")
  },
  {
    name: "investments___en",
    path: "/en/investments",
    meta: { ...(investmentsl0PjMYZF6SB_45xLDy3gwmmPuuCGCbpoCTSkk6Yx4LdWEMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/dev_web/pages/investments.vue")
  },
  {
    name: "investments___vi",
    path: "/vi/investments",
    meta: { ...(investmentsl0PjMYZF6SB_45xLDy3gwmmPuuCGCbpoCTSkk6Yx4LdWEMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/dev_web/pages/investments.vue")
  },
  {
    name: "investments___cn",
    path: "/cn/investments",
    meta: { ...(investmentsl0PjMYZF6SB_45xLDy3gwmmPuuCGCbpoCTSkk6Yx4LdWEMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/dev_web/pages/investments.vue")
  },
  {
    name: "account-edit___en___default",
    path: "/account-edit",
    meta: { ...(account_45editYCiTAZeFE_8ODzepXs6BmkBv1qbbPoxQoHgE4aBrMSEMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/dev_web/pages/account-edit.vue")
  },
  {
    name: "account-edit___en",
    path: "/en/account-edit",
    meta: { ...(account_45editYCiTAZeFE_8ODzepXs6BmkBv1qbbPoxQoHgE4aBrMSEMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/dev_web/pages/account-edit.vue")
  },
  {
    name: "account-edit___vi",
    path: "/vi/account-edit",
    meta: { ...(account_45editYCiTAZeFE_8ODzepXs6BmkBv1qbbPoxQoHgE4aBrMSEMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/dev_web/pages/account-edit.vue")
  },
  {
    name: "account-edit___cn",
    path: "/cn/account-edit",
    meta: { ...(account_45editYCiTAZeFE_8ODzepXs6BmkBv1qbbPoxQoHgE4aBrMSEMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/dev_web/pages/account-edit.vue")
  },
  {
    name: "login-qrcode___en___default",
    path: "/login-qrcode",
    meta: { ...(login_45qrcodeYBsX2u5TB5_zC0Gqf7Ci4U2w4mTGamA1x_450w2rVlSUsMeta || {}), ...{"middleware":["hidewhenauth"]} },
    component: () => import("D:/dev_web/pages/login-qrcode.vue")
  },
  {
    name: "login-qrcode___en",
    path: "/en/login-qrcode",
    meta: { ...(login_45qrcodeYBsX2u5TB5_zC0Gqf7Ci4U2w4mTGamA1x_450w2rVlSUsMeta || {}), ...{"middleware":["hidewhenauth"]} },
    component: () => import("D:/dev_web/pages/login-qrcode.vue")
  },
  {
    name: "login-qrcode___vi",
    path: "/vi/login-qrcode",
    meta: { ...(login_45qrcodeYBsX2u5TB5_zC0Gqf7Ci4U2w4mTGamA1x_450w2rVlSUsMeta || {}), ...{"middleware":["hidewhenauth"]} },
    component: () => import("D:/dev_web/pages/login-qrcode.vue")
  },
  {
    name: "login-qrcode___cn",
    path: "/cn/login-qrcode",
    meta: { ...(login_45qrcodeYBsX2u5TB5_zC0Gqf7Ci4U2w4mTGamA1x_450w2rVlSUsMeta || {}), ...{"middleware":["hidewhenauth"]} },
    component: () => import("D:/dev_web/pages/login-qrcode.vue")
  },
  {
    name: "order-result___en___default",
    path: "/order-result",
    meta: order_45result_45lzoBWYFP_0wTyU6tGHoUnIFgNrLzIPK86t7w5D6McEMeta || {},
    component: () => import("D:/dev_web/pages/order-result.vue")
  },
  {
    name: "order-result___en",
    path: "/en/order-result",
    meta: order_45result_45lzoBWYFP_0wTyU6tGHoUnIFgNrLzIPK86t7w5D6McEMeta || {},
    component: () => import("D:/dev_web/pages/order-result.vue")
  },
  {
    name: "order-result___vi",
    path: "/vi/order-result",
    meta: order_45result_45lzoBWYFP_0wTyU6tGHoUnIFgNrLzIPK86t7w5D6McEMeta || {},
    component: () => import("D:/dev_web/pages/order-result.vue")
  },
  {
    name: "order-result___cn",
    path: "/cn/order-result",
    meta: order_45result_45lzoBWYFP_0wTyU6tGHoUnIFgNrLzIPK86t7w5D6McEMeta || {},
    component: () => import("D:/dev_web/pages/order-result.vue")
  },
  {
    name: "recharge-log___en___default",
    path: "/recharge-log",
    meta: { ...(recharge_45logamm70Srqa4B6hv0F_45Vkba_85h3XOcMshJowVDkvRCTIMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/dev_web/pages/recharge-log.vue")
  },
  {
    name: "recharge-log___en",
    path: "/en/recharge-log",
    meta: { ...(recharge_45logamm70Srqa4B6hv0F_45Vkba_85h3XOcMshJowVDkvRCTIMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/dev_web/pages/recharge-log.vue")
  },
  {
    name: "recharge-log___vi",
    path: "/vi/recharge-log",
    meta: { ...(recharge_45logamm70Srqa4B6hv0F_45Vkba_85h3XOcMshJowVDkvRCTIMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/dev_web/pages/recharge-log.vue")
  },
  {
    name: "recharge-log___cn",
    path: "/cn/recharge-log",
    meta: { ...(recharge_45logamm70Srqa4B6hv0F_45Vkba_85h3XOcMshJowVDkvRCTIMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/dev_web/pages/recharge-log.vue")
  },
  {
    name: "transfer-log___en___default",
    path: "/transfer-log",
    meta: { ...(transfer_45logNsNKVj5Yu28dxNlTI0a9_45dl6XihsEU_45t_45NDODhxGRAsMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/dev_web/pages/transfer-log.vue")
  },
  {
    name: "transfer-log___en",
    path: "/en/transfer-log",
    meta: { ...(transfer_45logNsNKVj5Yu28dxNlTI0a9_45dl6XihsEU_45t_45NDODhxGRAsMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/dev_web/pages/transfer-log.vue")
  },
  {
    name: "transfer-log___vi",
    path: "/vi/transfer-log",
    meta: { ...(transfer_45logNsNKVj5Yu28dxNlTI0a9_45dl6XihsEU_45t_45NDODhxGRAsMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/dev_web/pages/transfer-log.vue")
  },
  {
    name: "transfer-log___cn",
    path: "/cn/transfer-log",
    meta: { ...(transfer_45logNsNKVj5Yu28dxNlTI0a9_45dl6XihsEU_45t_45NDODhxGRAsMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/dev_web/pages/transfer-log.vue")
  },
  {
    name: "order-checkout___en___default",
    path: "/order-checkout",
    meta: order_45checkout5S51eKSC_jjyMU2tcQd8hNweJ9pNO4VwMuDoDq3i0hwMeta || {},
    component: () => import("D:/dev_web/pages/order-checkout.vue")
  },
  {
    name: "order-checkout___en",
    path: "/en/order-checkout",
    meta: order_45checkout5S51eKSC_jjyMU2tcQd8hNweJ9pNO4VwMuDoDq3i0hwMeta || {},
    component: () => import("D:/dev_web/pages/order-checkout.vue")
  },
  {
    name: "order-checkout___vi",
    path: "/vi/order-checkout",
    meta: order_45checkout5S51eKSC_jjyMU2tcQd8hNweJ9pNO4VwMuDoDq3i0hwMeta || {},
    component: () => import("D:/dev_web/pages/order-checkout.vue")
  },
  {
    name: "order-checkout___cn",
    path: "/cn/order-checkout",
    meta: order_45checkout5S51eKSC_jjyMU2tcQd8hNweJ9pNO4VwMuDoDq3i0hwMeta || {},
    component: () => import("D:/dev_web/pages/order-checkout.vue")
  },
  {
    name: "reset-password___en___default",
    path: "/reset-password",
    meta: { ...(reset_45password6LKeNpPJyH8XCJ6969NtNmvwNPr_454t8_45KYEP_JMTx0YMeta || {}), ...{"middleware":["hidewhenauth"]} },
    component: () => import("D:/dev_web/pages/reset-password.vue")
  },
  {
    name: "reset-password___en",
    path: "/en/reset-password",
    meta: { ...(reset_45password6LKeNpPJyH8XCJ6969NtNmvwNPr_454t8_45KYEP_JMTx0YMeta || {}), ...{"middleware":["hidewhenauth"]} },
    component: () => import("D:/dev_web/pages/reset-password.vue")
  },
  {
    name: "reset-password___vi",
    path: "/vi/reset-password",
    meta: { ...(reset_45password6LKeNpPJyH8XCJ6969NtNmvwNPr_454t8_45KYEP_JMTx0YMeta || {}), ...{"middleware":["hidewhenauth"]} },
    component: () => import("D:/dev_web/pages/reset-password.vue")
  },
  {
    name: "reset-password___cn",
    path: "/cn/reset-password",
    meta: { ...(reset_45password6LKeNpPJyH8XCJ6969NtNmvwNPr_454t8_45KYEP_JMTx0YMeta || {}), ...{"middleware":["hidewhenauth"]} },
    component: () => import("D:/dev_web/pages/reset-password.vue")
  },
  {
    name: "shop-slug___en___default",
    path: "/shop/:slug(.*)*",
    meta: _91_46_46_46slug_93oKIuSffTVO_45ftBU9xPgKmAl25gBVH_oCJFMPItd91QgMeta || {},
    component: () => import("D:/dev_web/pages/shop/[...slug].vue")
  },
  {
    name: "shop-slug___en",
    path: "/en/shop/:slug(.*)*",
    meta: _91_46_46_46slug_93oKIuSffTVO_45ftBU9xPgKmAl25gBVH_oCJFMPItd91QgMeta || {},
    component: () => import("D:/dev_web/pages/shop/[...slug].vue")
  },
  {
    name: "shop-slug___vi",
    path: "/vi/shop/:slug(.*)*",
    meta: _91_46_46_46slug_93oKIuSffTVO_45ftBU9xPgKmAl25gBVH_oCJFMPItd91QgMeta || {},
    component: () => import("D:/dev_web/pages/shop/[...slug].vue")
  },
  {
    name: "shop-slug___cn",
    path: "/cn/shop/:slug(.*)*",
    meta: _91_46_46_46slug_93oKIuSffTVO_45ftBU9xPgKmAl25gBVH_oCJFMPItd91QgMeta || {},
    component: () => import("D:/dev_web/pages/shop/[...slug].vue")
  },
  {
    name: "change-password___en___default",
    path: "/change-password",
    meta: { ...(change_45passwordBXBwxR2orpLIkK7BtWkY2qdND4bbM_451yMeX_451Uv8CCkMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/dev_web/pages/change-password.vue")
  },
  {
    name: "change-password___en",
    path: "/en/change-password",
    meta: { ...(change_45passwordBXBwxR2orpLIkK7BtWkY2qdND4bbM_451yMeX_451Uv8CCkMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/dev_web/pages/change-password.vue")
  },
  {
    name: "change-password___vi",
    path: "/vi/change-password",
    meta: { ...(change_45passwordBXBwxR2orpLIkK7BtWkY2qdND4bbM_451yMeX_451Uv8CCkMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/dev_web/pages/change-password.vue")
  },
  {
    name: "change-password___cn",
    path: "/cn/change-password",
    meta: { ...(change_45passwordBXBwxR2orpLIkK7BtWkY2qdND4bbM_451yMeX_451Uv8CCkMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/dev_web/pages/change-password.vue")
  },
  {
    name: "checkout-paypal___en___default",
    path: "/checkout-paypal",
    meta: checkout_45paypalCdfGrQD529a7Gek6gusZsaGRzMtzyRpog63ModoLOJkMeta || {},
    component: () => import("D:/dev_web/pages/checkout-paypal.vue")
  },
  {
    name: "checkout-paypal___en",
    path: "/en/checkout-paypal",
    meta: checkout_45paypalCdfGrQD529a7Gek6gusZsaGRzMtzyRpog63ModoLOJkMeta || {},
    component: () => import("D:/dev_web/pages/checkout-paypal.vue")
  },
  {
    name: "checkout-paypal___vi",
    path: "/vi/checkout-paypal",
    meta: checkout_45paypalCdfGrQD529a7Gek6gusZsaGRzMtzyRpog63ModoLOJkMeta || {},
    component: () => import("D:/dev_web/pages/checkout-paypal.vue")
  },
  {
    name: "checkout-paypal___cn",
    path: "/cn/checkout-paypal",
    meta: checkout_45paypalCdfGrQD529a7Gek6gusZsaGRzMtzyRpog63ModoLOJkMeta || {},
    component: () => import("D:/dev_web/pages/checkout-paypal.vue")
  },
  {
    name: "forgot-password___en___default",
    path: "/forgot-password",
    meta: { ...(forgot_45passwordFRB76gsXqGS_452ijKfAri4cBi1pvK9Whh9VZxDma1hJoMeta || {}), ...{"middleware":["hidewhenauth"]} },
    component: () => import("D:/dev_web/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___en",
    path: "/en/forgot-password",
    meta: { ...(forgot_45passwordFRB76gsXqGS_452ijKfAri4cBi1pvK9Whh9VZxDma1hJoMeta || {}), ...{"middleware":["hidewhenauth"]} },
    component: () => import("D:/dev_web/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___vi",
    path: "/vi/forgot-password",
    meta: { ...(forgot_45passwordFRB76gsXqGS_452ijKfAri4cBi1pvK9Whh9VZxDma1hJoMeta || {}), ...{"middleware":["hidewhenauth"]} },
    component: () => import("D:/dev_web/pages/forgot-password.vue")
  },
  {
    name: "forgot-password___cn",
    path: "/cn/forgot-password",
    meta: { ...(forgot_45passwordFRB76gsXqGS_452ijKfAri4cBi1pvK9Whh9VZxDma1hJoMeta || {}), ...{"middleware":["hidewhenauth"]} },
    component: () => import("D:/dev_web/pages/forgot-password.vue")
  },
  {
    name: "checkout-balance___en___default",
    path: "/checkout-balance",
    meta: { ...(checkout_45balancesCjFrytgd_45TES8jvv4oQ3glNi8grAplHDM8Q_45lwSFFgMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/dev_web/pages/checkout-balance.vue")
  },
  {
    name: "checkout-balance___en",
    path: "/en/checkout-balance",
    meta: { ...(checkout_45balancesCjFrytgd_45TES8jvv4oQ3glNi8grAplHDM8Q_45lwSFFgMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/dev_web/pages/checkout-balance.vue")
  },
  {
    name: "checkout-balance___vi",
    path: "/vi/checkout-balance",
    meta: { ...(checkout_45balancesCjFrytgd_45TES8jvv4oQ3glNi8grAplHDM8Q_45lwSFFgMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/dev_web/pages/checkout-balance.vue")
  },
  {
    name: "checkout-balance___cn",
    path: "/cn/checkout-balance",
    meta: { ...(checkout_45balancesCjFrytgd_45TES8jvv4oQ3glNi8grAplHDM8Q_45lwSFFgMeta || {}), ...{"middleware":["auth"]} },
    component: () => import("D:/dev_web/pages/checkout-balance.vue")
  },
  {
    name: "checkout-success___en___default",
    path: "/checkout-success",
    meta: checkout_45successykrUJfWzhHTMizBtlTaYBXmgurT8__VvQnevrG1a5TQMeta || {},
    component: () => import("D:/dev_web/pages/checkout-success.vue")
  },
  {
    name: "checkout-success___en",
    path: "/en/checkout-success",
    meta: checkout_45successykrUJfWzhHTMizBtlTaYBXmgurT8__VvQnevrG1a5TQMeta || {},
    component: () => import("D:/dev_web/pages/checkout-success.vue")
  },
  {
    name: "checkout-success___vi",
    path: "/vi/checkout-success",
    meta: checkout_45successykrUJfWzhHTMizBtlTaYBXmgurT8__VvQnevrG1a5TQMeta || {},
    component: () => import("D:/dev_web/pages/checkout-success.vue")
  },
  {
    name: "checkout-success___cn",
    path: "/cn/checkout-success",
    meta: checkout_45successykrUJfWzhHTMizBtlTaYBXmgurT8__VvQnevrG1a5TQMeta || {},
    component: () => import("D:/dev_web/pages/checkout-success.vue")
  },
  {
    name: "order-qrcode-id___en___default",
    path: "/order-qrcode/:id()",
    meta: _91id_93P7Lr1Mw2Rhs3hADyWOFGtUH0Z6kBgwGU0rVVeJA0Wu0Meta || {},
    component: () => import("D:/dev_web/pages/order-qrcode/[id].vue")
  },
  {
    name: "order-qrcode-id___en",
    path: "/en/order-qrcode/:id()",
    meta: _91id_93P7Lr1Mw2Rhs3hADyWOFGtUH0Z6kBgwGU0rVVeJA0Wu0Meta || {},
    component: () => import("D:/dev_web/pages/order-qrcode/[id].vue")
  },
  {
    name: "order-qrcode-id___vi",
    path: "/vi/order-qrcode/:id()",
    meta: _91id_93P7Lr1Mw2Rhs3hADyWOFGtUH0Z6kBgwGU0rVVeJA0Wu0Meta || {},
    component: () => import("D:/dev_web/pages/order-qrcode/[id].vue")
  },
  {
    name: "order-qrcode-id___cn",
    path: "/cn/order-qrcode/:id()",
    meta: _91id_93P7Lr1Mw2Rhs3hADyWOFGtUH0Z6kBgwGU0rVVeJA0Wu0Meta || {},
    component: () => import("D:/dev_web/pages/order-qrcode/[id].vue")
  },
  {
    name: "checkout-paypal-success___en___default",
    path: "/checkout-paypal-success",
    meta: checkout_45paypal_45successCKEVeQKCr_45jMHGoGHnntiYTDHBnzDWGlRuh2eTsKOAgMeta || {},
    component: () => import("D:/dev_web/pages/checkout-paypal-success.vue")
  },
  {
    name: "checkout-paypal-success___en",
    path: "/en/checkout-paypal-success",
    meta: checkout_45paypal_45successCKEVeQKCr_45jMHGoGHnntiYTDHBnzDWGlRuh2eTsKOAgMeta || {},
    component: () => import("D:/dev_web/pages/checkout-paypal-success.vue")
  },
  {
    name: "checkout-paypal-success___vi",
    path: "/vi/checkout-paypal-success",
    meta: checkout_45paypal_45successCKEVeQKCr_45jMHGoGHnntiYTDHBnzDWGlRuh2eTsKOAgMeta || {},
    component: () => import("D:/dev_web/pages/checkout-paypal-success.vue")
  },
  {
    name: "checkout-paypal-success___cn",
    path: "/cn/checkout-paypal-success",
    meta: checkout_45paypal_45successCKEVeQKCr_45jMHGoGHnntiYTDHBnzDWGlRuh2eTsKOAgMeta || {},
    component: () => import("D:/dev_web/pages/checkout-paypal-success.vue")
  }
]